import { MOCK } from "utils/constants";
import * as recommandation from "./va";
import * as recommandationMock from "./va.mock";

export const getStatusVA = MOCK
  ? recommandationMock.getStatusVA
  : recommandation.getStatusVA;

export const getChecklist = MOCK
  ? recommandationMock.getChecklist
  : recommandation.getChecklist;

export const getChecklistByIdVistoria = MOCK
  ? recommandationMock.getChecklist
  : recommandation.getChecklistByIdVistoria;

export const postChecklist = MOCK
  ? recommandationMock.postChecklist
  : recommandation.postChecklist;

export const postVistoriaLogin = MOCK
  ? recommandationMock.postVistoriaLogin
  : recommandation.postVistoriaLogin;

export const postVistoriaLoginCohab = MOCK
  ? recommandationMock.postVistoriaLogin
  : recommandation.postVistoriaLoginCohab;

export const downloadLaudo = MOCK
  ? recommandationMock.downloadLaudo
  : recommandation.downloadLaudo;

export const vaEcDownloads = MOCK
  ? recommandationMock.vaEcDownloads
  : recommandation.vaEcDownloads;

export const downloadLaudoNew = MOCK
  ? recommandationMock.downloadLaudoNew
  : recommandation.downloadLaudoNew;
